<template>
  <div
    class="nav scrollbar"
    :class="{
      hide: routerView === 'courseDetail' || routerView === 'prepareDetail' || $route.meta.mlz,
      show: isNavPull
    }"
  >
    <div :class="skipStatus ? 'portraitSkip' : 'portrait'" @click="modal">
      <div class="avatar pointer">
        <div class="id" v-if="user.role_id !== 40001">{{ user.role_id | roleFilter }}</div>
        <div class="avatar" style="overflow: hidden">
          <img :src="user.avatar_url" style="width: 100%; height: 100%" />
        </div>
      </div>
      <p class="name">
        <text-with-tip :content="user.real_name || user.fullname || user.nickname" />
      </p>
      <div class="school" v-if="showUnitValue && !skipStatus">
        <!-- <span :class="haveNewMessage ? 'school-update' : ''">{{ user.unit_name }}</span> -->
        <text-with-tip :keepLength="6" :content="user.unit_name ? user.unit_name : '暂无单位信息'" />
        <!-- <span>{{ user.unit_name ? user.unit_name : '暂无单位信息' }}</span> -->
        <!-- 有学校信息 => 未审核展示 => 审核不通过展示 -->
        <el-button
          :type="
            schoolInfo ? (schoolInfo.handled ? (schoolInfo.passed ? '' : 'danger') : 'warning') : ''
          "
          size="mini"
          round
          :class="[
            'reset-button',
            schoolInfo.handled
              ? schoolInfo.passed
                ? ''
                : 'reset-button-unpassed'
              : 'reset-button-handle'
          ]"
          v-if="
            schoolInfo ? (schoolInfo.handled ? (schoolInfo.passed ? false : true) : true) : false
          "
        >
          {{ schoolInfo.handled ? (schoolInfo.passed ? '审核通过' : '审核不通过') : '审核中' }}
        </el-button>
      </div>
      <div v-show="skipStatus" @click="perfectMsg" class="skip-button">
        <span class="skip-text">完善个人资料</span>
      </div>
      <p class="phone" v-if="user.phone">{{user.phone}}</p>
      <p
        class="phone"
        v-if="!user.phone && isCustom && !isCustom.url.indexOf('nc')"
        style="color: red"
      >
        未绑定
      </p>
      <p v-if="isWeakPassword" class="weak-passwod">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
          <g fill="none" fill-rule="nonzero">
            <circle cx="7" cy="7" r="7" fill="currentColor" opacity=".4"></circle>
            <rect width="2" height="6" x="6" y="2.506" fill="#FFF" rx="1"></rect>
            <path fill="#FFF" d="M7 11.506a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
          </g>
        </svg>
        请重新设置密码，谨防被盗
      </p>
    </div>
    <div class="menu">
      <div
        class="menu-item vertical"
        :class="{ active: active === item.path, 'course-teaching': item.path === 'courseTeaching' }"
        v-for="(item, index) in menus"
        :key="index"
        @click="selectRoute(item.path)"
      >
        <div class="icon" :style="{'background-position':item.position}"></div>
        <span class="label">{{item.name}}
          <img class="label_icon"
            v-if="(item.path === 'courseManage' && isTeacher) && !guidePayload.openLessonStatus"
            src="~@/assets/image/newcourse_icon.png" alt="领取最新课程">
        </span>
      </div>
    </div>
    <el-dialog
      :visible.sync="showModal"
      show-close
      width="450px"
      v-if="showModal"
      :close-on-click-modal="false"
    >
      <div slot="title" class="modalTitle">
        <div class="tab" :class="activeTab === 1 ? 'activeTab' : ''" @click="tabClick(1)">
          个人资料
        </div>
        &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
        <div
          :class="{
            tab: true,
            activeTab: activeTab === 2,
            'disabled-warp': user.isThirdUserType1
          }"
          @click="tabClick(2)"
        >
          修改密码
        </div>
      </div>
      <info-form v-if="activeTab === 1" @closeModal="closeModal" />
      <pwd-form v-if="activeTab === 2" @closeModal="closeModal" />
    </el-dialog>
  </div>
</template>

<script>
import InfoForm from './infoForm'
import PwdForm from './pwdForm'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    InfoForm,
    PwdForm
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else {
        const phoneNumberCheck = /^(0|86|17951)?(1[3-9])\d{9}$/
        if (phoneNumberCheck.test(value) === false) {
          callback(new Error('请输入正确的手机号'))
        }
        callback()
      }
    }
    const validatePhoneNumberConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入手机号码'))
      } else {
        if (this.reMoibleForm.phone_number !== this.reMoibleForm.phone_number_con) {
          callback(new Error('手机号不匹配'))
        }

        callback()
      }
    }

    return {
      active: '',
      names: ['空间主页', '班级管理', '学生管理', '作品管理', '创作工具'],
      showModal: false,
      activeTab: 1,
      editMobile: false,
      showReMoible: false,
      guidePayload: {
        helperCenterStatus: true,
        openLessonStatus: true
      },
      reMoibleForm: {
        phone_number: '',
        phone_number_con: ''
      },
      reMoibleFormTeacher: {
        mobile: '',
        captcha: ''
      },
      reMoibleRules: {
        phone_number: [{ validator: validatePhoneNumber, trigger: 'blur' }],
        phone_number_con: [{ validator: validatePhoneNumberConfirm, trigger: 'blur' }]
      },
      reMoibleRulesTeacher: {
        mobile: [{ validator: validatePhoneNumber, trigger: 'blur' }]
      }
    }
  },
  filters: {
    roleFilter(id) {
      switch (id) {
        case 10001:
          return '教管'
        case 10002:
          return '教师'
        case 20001:
          return '学生'
        default:
          return ''
      }
    }
  },
  computed: {
    ...mapState(['user', 'dashboard', 'customInfo', 'isWeakPassword', 'isNavPull', 'lastMessage']),

    schoolInfo() {
      return this.$store.state.schoolInfo
    },

    haveNewMessage() {
      return this.lastMessage
    },

    menus() {
      return this.dashboard.menu
    },
    isCustom() {
      return this.customInfo
    },
    role_id() {
      return this.user.role_id
    },
    isStudent() {
      return this.user.role_id === 20001
    },
    isTeacher() {
      return this.user && (this.user.role_id === 10001 || this.user.role_id === 10002)
    },
    showUnitValue() {
      return this.user.role_id !== 40001 && this.user.role_id !== 20001
    },
    skipStatus () {
      return this.user.skipStatus && this.user.role_id !== 20001
    },
    user_id() {
      return this.user.id
    }
  },
  methods: {
    ...mapMutations({
      setCustomMenus: 'SET_CUSTOM_MENUS'
    }),
    longStringSlice(val = '', len = 15) {
      if (val.length > len) {
        return `${val.slice(0, len)}...`
      }
      return val
    },
    selectRoute(path) {
      this.$store.dispatch('eduCommonReport', {
        key: `entry_${path}`
      })
      if (path === 'tower') {
        this.routerTo('tower')
        return
      }
      if (path === 'courseManage' && this.isTeacher) {
        this.setGuideType('openLessonStatus', 2)
      }
      if (path === this.$route.name) {
        this.$router.push({
          name: path,
          query: {
            t: +new Date()
          }
        })
      } else {
        this.$router.push({
          name: path
        })
      }
    },
    // 跳转完善个人信息页
    perfectMsg() {
      this.$store.dispatch('eduCommonReport', {
        key: 'clickCpInfoBtn'
      })
      this.$router.push({
        name: 'completeMsg'
      })
    },
    closeModal() {
      this.showModal = false
    },
    async routerTo(item) {
      window.open(
        `${CONFIG[item]}?source=classroom_homepage_entrance&utm_source=edu&utm_medium=web&utm_campaign=homepage`
      )
    },
    modal() {
      // this.activeTab = 1
      // this.showModal = true
      if (!this.skipStatus) {
        this.perfectMsg()
      }
    },
    tabClick(tab) {
      // 西安工业云第三方登录用户 不能修改密码
      if (tab === 2 && this.user.isThirdUserType1) {
        return
      }
      if (tab === 2 && !this.user.phone && this.$store.getters.roleType !== 'student') {
        this.$message.error('请先绑定手机')
        return this.$store.commit('setState', {
          module: 'base',
          key: 'bindPhone',
          value: {
            type: 'bind', // rebind | bind
            status: true
          }
        })
      }
      this.activeTab = tab
    },
    // 获取引导状态
    async getGuideType() {
      const { data } = await this.$store.dispatch('getGuideType')
      this.guidePayload = data
      console.log('this.guidePayload', this.guidePayload)
    },
    // 设置引导状态
    async setGuideType(key, remindType) {
      // helperCenterStatus: 3
      // openLessonStatus: 2
      if (!this.guidePayload[key]) {
        await this.$store.dispatch('setGuideType', remindType)
        this.guidePayload[key] = true
      }
    }
  },
  mounted() {
    this.active = this.$route.name
    this.$store.dispatch('getMessageLast')
    this.$nextTick(() => {
      this.getGuideType()
    })
  },
  watch: {
    $route(to) {
      this.active = to.name
    }
  }
}
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}

.show {
  display: block;
}

.nav {
  height: 100vh;
  // height: calc(100vh - 60px);
  width: 200px;
  background-color: #ffffff;
  overflow: auto;
  box-shadow: 4px 0px 8px 0px rgba(233, 233, 233, 0.8);
  position: sticky;
  top: 0;
  // z-index: 10;
}
// .navnew {
//   height: 100vh;
// }

.menu {
  min-height: calc(100% - 280px);
  background-color: #ffffff;
  cursor: pointer;
}

.menu-item {
  padding: 15px 0px 15px 30px;
  display: flex;
  color: #2d2f33;
  &:hover {
    background-color: rgba(var(--primary-color-source), 0.1);
  }
  &.course-teaching .icon {
    background-image: url('../../assets/image/icn_teacher@2x.png');
    background-size: contain;
  }
}

i {
  color: #475669;
}

.label {
  position: relative;
  font-size: 16px;
  margin-left: 30px;
  color: #475669;
}
.label_icon {
  width: 76px;
  position: absolute;
  top: -25px;
  right: -45px;
}
.active {
  background-color: rgba(var(--primary-color-source), 0.1) !important;
}

.portraitSkip {
  width: 100%;
  padding: 38px 0;
  background: #fff;
  position: inherit;
}
.portrait {
  width: 100%;
  padding: 38px 0;
  cursor: pointer;
  background: #fff;
  position: inherit;
  &:hover {
    background: #fff;
    opacity: 0.6;
  }
}

p {
  text-align: center;
  line-height: 30px;
}

.school {
  font-size: 12px;
  text-align: center;
}
.school-update {
  position: relative;
  &:after {
    position: absolute;
    right: 0;
    top: 0;
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f5222d;
  }
}

.phone {
  font-size: 12px;
}

.modalTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 15px 0 15px;
  border-bottom: 1px #ccc solid;
  margin: 0 50px;
}

.activeTab {
  border-bottom: 3px solid #399aca;
  color: #399aca;
  transform: scale(1.2);
}

.tab {
  cursor: pointer;
  padding: 0 5px;
}

.id {
  width: 36px;
  height: 36px;
  border-radius: 20px;
  background: #fd8200;
  position: absolute;
  right: -16px;
  top: -10px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px #fd8200;
  border: 2px #fff solid;
  font-size: 12px;
  color: #fff;
}

.avatar {
  width: 80px;
  height: 80px;
  // overflow: hidden;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  border: #ccc 1px solid;
  // overflow: hidden;
  // &:hover {
  //   opacity: 0.9;
  // }
}

.modal {
  width: 360px;
  min-width: 360px;
}

.icon {
  width: 26px;
  height: 26px;
  background-image: url('https://public-static-edu.codemao.cn/redboat/icons_20191204.svg');
  background-repeat: no-repeat;
}

.weak-passwod {
  color: #f7596c;
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: initial;
  svg {
    height: 12px;
    margin-right: 3px;
  }
}

.auth_code {
  width: 149px;
  height: 40px;
  text-align: center;
  background-color: var(--primary-el-color);
  color: #fff;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  margin-left: 8px;
  position: absolute;
}

.unAnth_code {
  width: 149px;
  height: 40px;
  text-align: center;
  background-color: #d8d8d8;
  color: #666666;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  margin-left: 8px;
  position: absolute;
}

.auth_code:hover {
  background-color: #ffd14f;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  background-color: #d8d8d8 !important;
}
.skip-button {
  width: 120px;
  padding: 5px 10px;
  background: #E3F8F5;
  border-radius: 15px;
  border: 1px solid #00C4AA;
  cursor: pointer;
  margin: 5px auto;
  text-align: center;
}
.skip-text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #00C4AA;
  line-height: 20px;
}
.reset-button {
  height: 20px;
  line-height: 20px;
  padding: 0 10px !important;
  border-color: transparent !important;
}
.reset-button-handle {
  color: #ffa21f;
  background-color: #fffbe6;
  &:hover {
    color: #ffa21f;
    background-color: #fffbe6;
  }
  &:focus {
    color: #ffa21f;
    background-color: #fffbe6;
  }
}
.reset-button-unpassed {
  color: #f5222d;
  background: rgba(245, 34, 45, 0.1);
  &:hover {
    color: #f5222d;
    background: rgba(245, 34, 45, 0.1);
  }
  &:focus {
    color: #f5222d;
    background: rgba(245, 34, 45, 0.1);
  }
  .disabled-warp {
    color: #bcbec2;
    background-color: #f4f4f5;
  }
}
</style>
